/** @format */

// A23-themed assets only
import a23Logo from "../Logo.png";
import a23backArrow from "../arrow-left.svg";
import a23cashIcon from "../cash-icon.svg";
import a23downArrow from "../down-arrow.svg";
import a23cashBill from "../cash-bill.svg";
import a23rightArrow from "../right-arrow.svg";
import a23user from "../user.svg";
import a23crown from "../crown.svg";
import a23homeBanner from "../homeBanner.svg";
import a23gridCash from "../GridCash.svg";
import a23gridFreeRoll from "../GridFreeRoll.svg";
import a23gridTourney from "../GridTourney.svg";
import a23gridPractice from "../GridPractice.svg";
import a23wallet from "../GoldWalletIcon.svg";
import a23footerHome from "../footerHome.svg";
import a23footerCash from "../footerCash.svg";
import a23footerTourney from "../footerTourney.svg";
import a23footerWallet from "../footerWallet.svg";
import a23table1 from "../a23table.png";
import a23table2 from "../Table-2.png";
import a23table3 from "../Table-3.png";
import a23table4 from "../Table-4.png";
import a23table5 from "../Table-5.png";
import a23miniTable from "../miniGameTable.svg";
import a23brandChip from '../a23brandChip.png';
import a23brandChip2 from '../a23brandChip2.png';
import a23redChip from "../chips.svg";
import a23blueChip from "../chip-blue.svg";
import a23yellowChip from "../chip-yellow.svg";
import a23blackChip from "../chip-black.svg";
import a23greenChip from "../chip-green.svg";
import a23checkIcon from "../Check.png";
import a23foldIcon from "../Fold.png";
import a23dealerIcon from "../Dealer.png";
import a23reserved from "../reserved.svg";
import a23verticalLogo from "../a23VerticalLogo.png";
import a23bulb from "../bulb.svg";
import a23redWinnerLottie from "../RedWinner.json";
import a23blueWinnerLottie from "../BlueWinner.json";
import a23greenWinnerLottie from "../GreenWinner.json";
import a23goldWinnerLottie from "../GoldWinner.json";
import a23grayWinnerLottie from "../GrayWinner.json";
import a23star from "../TourneyStar.svg";
import a23megaTournament from "../MegaTournament.svg";
import a23RITIcon from "../RIT.svg";
import a23StraddleIcon from "../straddle.svg";
import a23turboIcon from "../turbo.svg";
import a23CashGamesIcon from "../A23CashGames.png";
import a23TourneyIcon from "../A23Tournaments.png";
import a23anonymous from "../incognito.png";
import a23RankGraph from "../rankGraphA23.svg";
import a23coffee from "../coffee-icon.png";
import a23cardback from "../cardback.png";
import a23FallbackCards from "../a23FallbackCards.svg";

// A23 Avatars
import a23lion from "../avatars/lion.png";
import a23croc from "../avatars/crocodile.png";
import a23fox from "../avatars/fox.png";
import a23owl from "../avatars/owl.png";
import a23polarbear from "../avatars/polarbear.png";
import a23shark from "../avatars/shark.png";

// A23 Take Seat Lottie
import a23TakeSeatLottie from "../sit-here-lottie.json";

// A23 Poker Chips
import a23pokerChips from "../PokerChips.json";
import a23didYouKnow from "../didYouKnow.svg";

// Common assets (no A23/A52 prefix)
import eyeIcon from "../eye.svg";
import filterIcon from "../filter-icon.svg";
import layersIcon from "../layers.svg";
import tourneyFilters from "../TourneyFilter.svg";
import tourneyActiveFilters from "../TourneyActiveFilters.svg";
import tourneyTick from "../RegisteredTick.svg";
import OneShot from "../OneShot.svg";
import CashGame from "../CashGames.svg";
import bellInactive from "../bell-inactive.svg";
import TourneyDetailsOverviewCard from "../TourneyDetailsOverviewCard.svg";
import RupeeIcon from "../RupeeIcon.svg";
import InfoIcon from "../InfoIcon.svg";
import CurrencyNoteIcon from "../CurrencyNoteIcon.svg";
import PodiumIcon from "../PodiumIcon.svg";
import PodiumRank1 from "../PodiumRank1.svg";
import PodiumRank2 from "../PodiumRank2.svg";
import PodiumRank3 from "../PodiumRank3.svg";
import DownArrowCircleIcon from "../DownArrowCircleIcon.svg";
import ChipsStackIcon from "../ChipsStackIcon.svg";
import TrophyLargeIcon from "../TrophyLargeIcon.svg";
import TicketIcon from "../TicketIcon.svg";
import CoffeeCupIcon from "../CoffeeCupIcon.svg";
import UserGroupIcon from "../UserGroupIcon.svg";
import ClockIcon from "../ClockIcon.svg";
import RefreshIcon from "../RefreshIcon.svg";
import GameTableIcon from "../GameTableIcon.svg";
import ChevronRight from "../ChevronRight.svg";
import TableEmptyState from "../TableEmptyState.svg";
import EventStarIcon from "../EventStarIcon.svg";
import Bounty10K from "../Bounty10K.svg";
import Bounty20K from "../Bounty20K.svg";
import Bounty30K from "../Bounty30K.svg";
import Bounty40K from "../Bounty40K.svg";
import Bounty50K from "../Bounty50K.svg";
import Bounty8K from "../Bounty8K.svg";
import BountyOthers from "../BountyOthers.svg";
import statsPlayerTable from "../statsPlayerTable.svg";
import rupeePrize from "../rupeePrize.svg";
import EmptyFolder from "../EmptyFolder.png";
import tourneyCup from "../TourneyCup.svg";
import dealGoldIcon from "../DealGoldIcon.png";
import dealGrayIcon from "../DealGrayIcon.png";
import dealStackIcon from "../DealStackIcon.png";
import greenUpArrow from "../GreenUpArrow.png";
import dealAccepted from "../dealAccepted.png";
import dealRejected from "../dealRejected.png";
import GoldTicket from "../GoldTicket.svg";
import SilverTicket from "../SilverTicket.svg";
import NewChipStack from "../NewChipStack.svg";
import Rank1Icon from "../Rank1Icon.svg";
import Rank2Icon from "../Rank2Icon.svg";
import Rank3Icon from "../Rank3Icon.svg";
import ChipStackSecondary from "../ChipStackSecondary.svg";
import ParentTourneyStarIcon from '../ParentTourneyStarIcon.svg'
// import a23coffee from "../coffeeLottie.json";
import a23Ellipse from "../a23Ellipse.svg";


const gameAssets = {
    // Primary assets
    primaryLogo: a23Logo,
    verticalLogo: a23verticalLogo,
    wallet: a23wallet,

    // How To Play
    bulb: a23bulb,

    // Navigation icons
    backArrow: a23backArrow,
    rightArrow: a23rightArrow,
    downArrow: a23downArrow,
    takeSeatLottie: a23TakeSeatLottie,

    // Feature icons
    cashIcon: a23cashIcon,
    userIcon: a23user,

    // Game specific icons
    cashBill: a23cashBill,
    crown: a23crown,
    cashGames: a23CashGamesIcon,
    tourneys: a23TourneyIcon,

    // Hero Banners
    homeBanner: a23homeBanner,
    gridCash: a23gridCash,
    gridTourney: a23gridTourney,
    gridPractice: a23gridPractice,
    gridFreeRoll: a23gridFreeRoll,

    // Footer Icons
    footerCash: a23footerCash,
    footerHome: a23footerHome,
    footerTourney: a23footerTourney,
    footerWallet: a23footerWallet,

    // Game Tables
    gameTable1: a23table1,
    gameTable2: a23table2,
    gameTable3: a23table3,
    gameTable4: a23table4,
    gameTable5: a23table5,
    miniGameTable: a23miniTable,

    // Game Backgrounds
    // gameBackground1: a23gameBackground,

    // Player
    lion: a23lion,
    owl: a23owl,
    fox: a23fox,
    polarbear: a23polarbear,
    crocodile: a23croc,
    shark: a23shark,

    // Poker Chips
    redChip: a23redChip,
    blueChip: a23blueChip,
    yellowChip: a23yellowChip,
    blackChip: a23blackChip,
    greenChip: a23greenChip,
    brandChip: a23brandChip,
    brandChip2: a23brandChip2,

    // Cards
    cardback: a23cardback,

    // Game Icons
    check: a23checkIcon,
    fold: a23foldIcon,
    dealer: a23dealerIcon,
    reserved: a23reserved,
    coffee: a23coffee,

    // Winner Lotties
    redWinner: a23redWinnerLottie,
    blueWinner: a23blueWinnerLottie,
    greenWinner: a23greenWinnerLottie,
    grayWinner: a23grayWinnerLottie,
    goldWinner: a23goldWinnerLottie,

    // Poker Game Loader
    pokerChips: a23pokerChips,
    didYouKnow: a23didYouKnow,

    // Stats Corner
    rankGraph: a23RankGraph,

    // Tourney Lists
    tourneyStar: a23star,
    tourneyMega: a23megaTournament,
    a23FallbackCards: a23FallbackCards,

    // Game Icons
    rit: a23RITIcon,
    straddle: a23StraddleIcon,
    turbo: a23turboIcon,
    anonymous: a23anonymous,

    // Common assets
    eyeIcon: eyeIcon,
    filterIcon: filterIcon,
    layersIcon: layersIcon,
    tourneyFilter: tourneyFilters,
    tourneyActiveFilters: tourneyActiveFilters,
    registeredTick: tourneyTick,
    tourneyOneShot: OneShot,
    tourneyCup: tourneyCup,
    rupeePrize: rupeePrize,
    EmptyFolder: EmptyFolder,
    statsPlayerTable: statsPlayerTable,
    dealGoldIcon: dealGoldIcon,
    dealGrayIcon: dealGrayIcon,
    dealStackIcon: dealStackIcon,
    greenUpArrow: greenUpArrow,
    dealAccepted: dealAccepted,
    dealRejected: dealRejected,

    // TourneyDetails Assets
    bellInactive: bellInactive,
    TourneyDetailsOverviewCard: TourneyDetailsOverviewCard,
    RupeeIcon: RupeeIcon,
    CurrencyNoteIcon: CurrencyNoteIcon,
    PodiumIcon: PodiumIcon,
    PodiumRank1: PodiumRank1,
    PodiumRank2: PodiumRank2,
    PodiumRank3: PodiumRank3,
    DownArrowCircleIcon: DownArrowCircleIcon,
    ChipsStackIcon: ChipsStackIcon,
    TrophyLargeIcon: TrophyLargeIcon,
    TicketIcon: TicketIcon,
    CoffeeCupIcon: CoffeeCupIcon,
    UserGroupIcon: UserGroupIcon,
    ClockIcon: ClockIcon,
    RefreshIcon: RefreshIcon,
    GameTableIcon: GameTableIcon,
    TableEmptyState: TableEmptyState,
    EventStarIcon: EventStarIcon,
    Bounty10K: Bounty10K,
    Bounty20K: Bounty20K,
    Bounty30K: Bounty30K,
    Bounty40K: Bounty40K,
    Bounty50K: Bounty50K,
    Bounty8K: Bounty8K,
    BountyOthers: BountyOthers,
    GoldTicket: GoldTicket,
    SilverTicket: SilverTicket,
    rank1Icon: Rank1Icon,
    rank2Icon: Rank2Icon,
    rank3Icon: Rank3Icon,
    NewChipStack: NewChipStack,
    ChipStackSecondary: ChipStackSecondary,
    ParentTourneyStarIcon: ParentTourneyStarIcon,

    // Feature icons
    InfoIcon: InfoIcon,
    ChevronRight: ChevronRight,

    // Cash Game
    cashGames: CashGame,
    radialEllipse: a23Ellipse,
};

export default gameAssets;